import React from 'react'
import { Box } from '@mui/material'
import { styles } from '../styles'

const DividerBlock: React.FC = () => <Box aria-label="divider-block" sx={styles.divider} />

export default DividerBlock
